import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { required, maxLength, nullable, validateValueIsUnique } from '../../shared/forms/validators';

const validateTLSAccount = validateValueIsUnique({
  optionsKey: 'tlsAccountsOptions',
  message: 'TLS Account already exists.',
  conditionFn: (option, selectedValue, context) =>
    option.value === selectedValue && option.account !== context.parent.account,
});

const schema = ({ categoriesWithTags }) => [
  {
    name: 'account',
    component: InputFormik,
    meta: { label: 'Account', optionsKey: 'tlsAccountsOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(),
      validationRules: [required, maxLength(13), validateTLSAccount] },
    additionalProps: { required: true },
  },
  {
    name: 'description',
    component: InputFormik,
    meta: { label: 'Account Description' },
    options: { yupType: yupString(), validationRules: [required, maxLength(240)] },
    additionalProps: { required: true },
  },
  {
    name: 'enabledFlag',
    component: SelectFormik,
    meta: { label: 'Enabled Flag', optionsKey: 'enabledFlagOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'allowAdjFlag',
    component: SelectFormik,
    meta: { label: 'Allow Account Based Adjustments', optionsKey: 'enabledFlagOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'preTaxFlag',
    component: SelectFormik,
    meta: { label: 'Pre Tax', optionsKey: 'enabledFlagOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  ...categoriesWithTags.map(({ categoryName, description, tags }) =>
    ({
      name: categoryName,
      component: SelectFormik,
      meta: { label: description, options: tags },
      options: { yupType: yupString(), validationRules: [nullable] },
      additionalProps: { clearable: true, virtualized: true },
    })
  ),
];

export default schema;
